import { upsaleTemplate } from 'assets/images';
import { routePaths } from 'global/routePaths';

// TODO: Make this internationalized
const upsaleTypes = {
  jobs: {
    heading: 'Timeero Jobs Pro Feature',
    description: 'Take the stress out of scheduling and save on average 30 hours a week by using Timeero',
    learnMoreLink: 'https://timeero.com/pricing',
    upgradeLink: routePaths.accountBilling.upgrade,
    featureList: [
      'Simple, Powerful and Easy Schedule to Use',
      'Option to create and edit schedules in real-time',
      'Send notifications and schedule updates to your employees',
      'Eliminate schedule conflicts',
    ],
    heroImg: upsaleTemplate,
  },
  'message-blast': {
    heading: 'Timeero Message Blast Pro Feature',
    description: 'Take the stress out of scheduling and save on average 30 hours a week by using Timeero',
    learnMoreLink: 'https://timeero.com/pricing',
    upgradeLink: routePaths.accountBilling.upgrade,
    featureList: [
      'Simple, Powerful and Easy Schedule to Use',
      'Option to create and edit schedules in real-time',
      'Send notifications and schedule updates to your employees',
      'Eliminate schedule conflicts',
    ],
    heroImg: upsaleTemplate,
  },
  scheduling: {
    heading: 'Timeero Scheduling Pro Feature',
    description: 'Take the stress out of scheduling and save on average 30 hours a week by using Timeero',
    learnMoreLink: 'https://timeero.com/pricing',
    upgradeLink: routePaths.accountBilling.upgrade,
    featureList: [
      'Simple, Powerful and Easy Schedule to Use',
      'Option to create and edit schedules in real-time',
      'Send notifications and schedule updates to your employees',
      'Eliminate schedule conflicts',
    ],
    heroImg: upsaleTemplate,
  },
  'time-off': {
    heading: 'Timeero Time Off Pro Feature',
    description: 'Take the stress out of scheduling and save on average 30 hours a week by using Timeero',
    learnMoreLink: 'https://timeero.com/pricing',
    upgradeLink: routePaths.accountBilling.upgrade,
    featureList: [
      'Simple, Powerful and Easy Schedule to Use',
      'Option to create and edit schedules in real-time',
      'Send notifications and schedule updates to your employees',
      'Eliminate schedule conflicts',
    ],
    heroImg: upsaleTemplate,
  },
  integrations: {
    heading: 'Timeero Integrations Pro Feature',
    description: 'Take the stress out of scheduling and save on average 30 hours a week by using Timeero',
    learnMoreLink: 'https://timeero.com/pricing',
    upgradeLink: routePaths.accountBilling.upgrade,
    featureList: [
      'Simple, Powerful and Easy Schedule to Use',
      'Option to create and edit schedules in real-time',
      'Send notifications and schedule updates to your employees',
      'Eliminate schedule conflicts',
    ],
    heroImg: upsaleTemplate,
  },
  'suggested-mileage': {
    heading: 'Timeero Suggested Mileage Pro Feature',
    description: 'Take the stress out of scheduling and save on average 30 hours a week by using Timeero',
    learnMoreLink: 'https://timeero.com/pricing',
    upgradeLink: routePaths.accountBilling.upgrade,
    featureList: [
      'Simple, Powerful and Easy Schedule to Use',
      'Option to create and edit schedules in real-time',
      'Send notifications and schedule updates to your employees',
      'Eliminate schedule conflicts',
    ],
    heroImg: upsaleTemplate,
  },
};

export default upsaleTypes;
